module.exports = __webpack_public_path__ + "static/img/btn_07.f3c7bc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/header/btn_07.png
// module id = F8rS
// module chunks = 4